module.exports = "<loans-page></loans-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/loans.html
// module id = 1870
// module chunks = 0